import i18n from 'scoreboard/components/i18n'
import _ from 'lodash'
import numericEvaluator from '../evaluators/numeric-evaluator'

/**
 * Validates that a value is greater than a contrasting minimum value, or
 * less than a contrasting maximum value.
 * @param getMinMaxInputValues function used to retrieve input values of min/max
 * @param context context used for given callback to retrieve min/max values
 * @return {minMaxValidator}
 */
function minMaxValidatorFactory(getMinMaxInputValues) {
	function minMaxValidator(val) {
		if (_.isEmpty(val)) {
			return
		}

		// Retrieve min max values from input fields with given context
		const { min: minVal, max: maxVal } = getMinMaxInputValues()

		// Parse val, min, and max values to numbers.
		// Returns the value as is if it is already a number
		// since numericEvaluator returns null for number values.
		const parseValue = (value) => _.isNumber(value) ?
			value : parseInt(numericEvaluator(value))

		const parsedVal = parseValue(val)
		const parsedMin = parseValue(minVal)
		const parsedMax = parseValue(maxVal)


		// If val is not a number, return error
		if (isNaN(parsedVal)) {
			return i18n.get('common.error.notANumber.tooltip')
		}

		if (_.isNumber(parsedMin) && _.isNumber(parsedMax) &&
			(parsedMax <= parsedMin || parsedMin >= parsedMax)
		) {
			return i18n.get('common.error.minMax.tooltip')
		}
	}
	return minMaxValidator
}

export default minMaxValidatorFactory

minMaxValidatorFactory.__filename__ = 'components/validators/min-max-validator-factory.js'
